import React from 'react';
import type { Language } from '../types';
import { getTranslation } from '../utils/translations';
import {
    ALLERGY_CONFIG,
    type KnownAllergyId,
    toggleKnownAllergy,
} from '../utils/allergies';

interface KnownAllergiesSelectorProps {
    value: KnownAllergyId[];
    onChange: (next: KnownAllergyId[]) => void;
    language?: Language;
    disabled?: boolean;
}

const KnownAllergiesSelector: React.FC<KnownAllergiesSelectorProps> = ({
    value,
    onChange,
    language = 'en',
    disabled = false,
}) => {
    const t = (key: Parameters<typeof getTranslation>[1]) => getTranslation(language, key);

    return (
        <div className="flex flex-wrap gap-2">
            {ALLERGY_CONFIG.map(({ id, labelKey, emoji }) => {
                const active = value.includes(id);
                return (
                    <button
                        key={id}
                        type="button"
                        disabled={disabled}
                        onClick={() => onChange(toggleKnownAllergy(value, id))}
                        className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-black uppercase tracking-wider transition-all border disabled:opacity-50
                            ${active
                                ? 'bg-amber-50 text-amber-800 border-amber-300 dark:bg-amber-900/30 dark:text-amber-200 dark:border-amber-700 shadow-sm'
                                : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border-slate-200 dark:border-slate-700 hover:border-slate-300'
                            }`}
                    >
                        <span className="text-sm leading-none">{emoji}</span>
                        {t(labelKey)}
                    </button>
                );
            })}
        </div>
    );
};

export default KnownAllergiesSelector;
